export default "__VITE_ASSET__BGhnNlDG__"